@let origItem = animalOrigItems[singleItemId!];
@if (origItem && !isEditingMode) {
  <p-panel
    class="mb-2 p-0"
    [ngClass]="origItem.shelterChanged ? 'with-shelter-change' : ''"
  >
      <ng-template #header>
          <div class="flex-1 p-2 text-xl font-semibold flex items-center gap-3 flex-wrap">
            @if (origItem.type) {
              <h3 class="inline">{{ 'animalOrigin.types.' + origItem.type | transloco }}</h3>
            }
            @if (origItem.location) {
              <h3 class="inline px-1">|</h3>
              <h3 class="inline">{{ origItem.location }}</h3>
            }
            @if (origItem.dateOfReceipt) {
              <h3 class="inline px-1">|</h3>
              <h3 class="inline">{{ origItem.dateOfReceipt | date: 'dd.MM.yyyy' }}</h3>
            }
            @if (hasReportPdf(origItem)) {
              <span class="inline-flex items-center gap-1">
                @if (origItem.reportSentOn) {
                  <span class="inline-flex items-center gap-1 text-sm font-normal text-green-600 bg-green-50 border border-green-300 rounded px-2 py-0.5 cursor-pointer"
                    [pTooltip]="(origItem.reportSentOn | date: 'dd.MM.yyyy') ?? ''"
                    tooltipPosition="right"
                        (click)="openSentEmailsDialog($event, sentEmailsByOriginId[origItem.id])">
                    <span class="pi pi-check-circle"></span>
                    PDF versendet
                  </span>
                } @else {
                  <span class="inline-flex items-center gap-1 text-sm font-normal text-orange-600 bg-orange-50 border border-orange-300 rounded px-2 py-0.5">
                    <span class="pi pi-exclamation-circle"></span>
                    PDF noch nicht versendet
                  </span>
                }
              </span>
            }
          </div>
        </ng-template>
      <div class="grid gap-2">
        <div class="col-span-12">
          <p-accordion [multiple]="true" [value]="['0', '1', '2', '3']">
            <p-accordion-panel value="0">
              <p-accordion-header>
                <div class="flex justify-between w-full items-center mr-2">
                  <span class="order-0">
                    {{ 'animalDetails.general.headline' | transloco }}
                  </span>
                  @if (!hasReportPdf(origItem)) {
                    <p-button
                      icon="pi pi-pen-to-square"
                      class="p-button-sm"
                      [text]="true"
                      [rounded]="true"
                      [raised]="true"
                      (click)="toggleEditDialog(true,'general', origItem.id)"
                    />
                  } @else {
                    <span>
                      <p-button
                        class="p-button-sm mr-1"
                        icon="pi pi-send"
                        [text]="true"
                        [rounded]="true"
                        [raised]="true"
                        label="PDF senden"
                        (click)="openSendPdf($event, $any(origItem))"
                      />
                      <p-button
                        (click)="openPdf($event, $any(origItem))"
                        class="p-button-sm"
                        icon="pi pi-file-pdf"
                        label="PDF anzeigen"
                        [text]="true"
                        [rounded]="true"
                        [raised]="true"
                      />
                    </span>
                  }
                </div>
              </p-accordion-header>
              <p-accordion-content>
                @if (origItem.type === animalOriginReasonForTransfer.SECURED_BY_POLICE) {
                  <app-secured-origin-details [origin]="origItem" />
                } @else if (
                  origItem.type ===
                  animalOriginReasonForTransfer.FOUND_ANIMAL && origItem.reportPdfPath?.length
                ) {
                  <ng-container
                    *ngTemplateOutlet="
                      foundAnimalDisplay;
                      context: { animalOrigItem: origItem }
                    "
                  />
                } @else {
                  <ng-container
                    *ngTemplateOutlet="
                      generalForm;
                      context: {
                        key: origItem.id,
                        animalOrigItem: origItem,
                      }
                    "
                  />
                }
              </p-accordion-content>
            </p-accordion-panel>

            @if (!origItem.shelterChanged) {
              <p-accordion-panel value="1">
                <p-accordion-header>
                  <div class="flex mr-2 justify-between w-full items-center">
                    <span class="order-0">
                      {{ 'contacts.headline' | transloco }}
                    </span>

                    @if (!hasReportPdf(origItem)) {
                      <span class="flex gap-2">
                        <p-button
                          icon="pi pi-plus"
                          class="p-button-sm"
                          [text]="true"
                          [rounded]="true"
                          [raised]="true"
                          (click)="openAddContactRef(origItem.id)"
                        />
                      </span>
                    }
                  </div>
                </p-accordion-header>

                <p-accordion-content>
                  @let refs = origItem.contacts ?? [];

                  @if (!refs.length) {
                    <span>{{ 'contacts.noContactExist' | transloco }}</span>
                  } @else {
                    <div class="flex flex-col gap-2">
                      @for (
                        ref of refs;
                        track ref.id ??
                          ref.type + '-' + ref.contact + '-' + $index;
                        let idx = $index
                      ) {
                        @let contactModel =
                          ref.contact ? contacts[ref.contact] : null;

                        <div class="border border-gray-200 rounded p-2">
                          <div class="flex items-center justify-between gap-3 mb-1">
                            <div class="min-w-0">
                              <div class="font-semibold">
                                {{ getContactTypeLabel(ref.type) }}
                                @if (ref.label) {
                                  <span class="font-normal text-gray-500">
                                    – {{ ref.label }}</span
                                  >
                                }
                              </div>
                            </div>

                            <div class="flex gap-2 shrink-0">
                              @if (ref.contact) {
                                <p-button
                                  [routerLink]="['/kontakte', ref.contact]"
                                  icon="pi pi-eye"
                                  [text]="true"
                                  [rounded]="true"
                                  [raised]="true"
                                />
                              }

                              @if (!hasReportPdf(origItem)) {
                                <p-button
                                  icon="pi pi-pen-to-square"
                                  [text]="true"
                                  [rounded]="true"
                                  [raised]="true"
                                  (click)="
                                    openEditContactRef(
                                      origItem.id,
                                      ref,
                                      idx
                                    )
                                  "
                                />

                                <p-button
                                  icon="pi pi-trash"
                                  severity="danger"
                                  [text]="true"
                                  [rounded]="true"
                                  [raised]="true"
                                  (click)="
                                    removeContactRef(
                                      origItem.id,
                                      ref,
                                      idx
                                    )
                                  "
                                />
                              }
                            </div>
                          </div>
                          @if (contactModel) {
                            <ng-container
                              *ngTemplateOutlet="
                                contactForm;
                                context: { contact: contactModel }
                              "
                            ></ng-container>
                          }
                        </div>
                      }
                    </div>
                  }
                </p-accordion-content>
              </p-accordion-panel>
            }
            <!-- Shelter Changed -->
            @if (origItem.shelterChanged) {
              <p-accordion-panel value="3">
                <p-accordion-header>
                  <div class="flex justify-between w-full items-center">
                    <span class="order-0">
                      {{ 'animalDetails.general.shelter.title' | transloco }}
                    </span>
                  </div>
                </p-accordion-header>
                <p-accordion-content>
                  @if (
                    animalSheltersById[origItem.animalShelter?.id];
                    as shelter
                  ) {
                    <div class="grid gap-2">
                      <div class="col-span-12">
                        <p-inputgroup>
                          <p-iftalabel>
                            <label for="animalShelter">
                              {{
                                'animalDetails.general.shelter.title'
                                  | transloco
                              }}
                            </label>
                            <input
                              type="text"
                              [class.no-border]="!isEditingMode"
                              pInputText
                              [value]="shelter.title"
                              id="animalShelter"
                              disabled
                            />
                          </p-iftalabel>
                        </p-inputgroup>
                      </div>
                      <div class="col-span-4">
                        <p-inputgroup>
                          <p-iftalabel>
                            <label for="animalShelter">
                              {{
                                'animalDetails.general.shelter.address'
                                  | transloco
                              }}
                            </label>
                            <input
                              type="text"
                              [class.no-border]="!isEditingMode"
                              pInputText
                              [value]="shelter.address"
                              id="animalShelterAddress"
                              disabled
                            />
                          </p-iftalabel>
                        </p-inputgroup>
                      </div>
                      <div class="col-span-4">
                        <p-inputgroup>
                          <p-iftalabel>
                            <label for="animalShelter">
                              {{
                                'animalDetails.general.shelter.zipCode'
                                  | transloco
                              }}
                            </label>
                            <input
                              type="text"
                              [class.no-border]="!isEditingMode"
                              pInputText
                              [value]="shelter.zipCode"
                              id="animalShelterZipCode"
                              disabled
                            />
                          </p-iftalabel>
                        </p-inputgroup>
                      </div>
                      <div class="col-span-4">
                        <p-inputgroup>
                          <p-iftalabel>
                            <label for="animalShelter">
                              {{
                                'animalDetails.general.shelter.city' | transloco
                              }}
                            </label>
                            <input
                              type="text"
                              [class.no-border]="!isEditingMode"
                              pInputText
                              [value]="shelter.city"
                              id="animalShelterCity"
                              disabled
                            />
                          </p-iftalabel>
                        </p-inputgroup>
                      </div>
                      <div class="col-span-6">
                        <p-inputgroup>
                          <p-iftalabel>
                            <label for="animalShelter">
                              {{
                                'animalDetails.general.shelter.phoneNumber'
                                  | transloco
                              }}
                            </label>
                            <input
                              type="text"
                              [class.no-border]="!isEditingMode"
                              pInputText
                              [value]="shelter.phoneNumber"
                              id="animalShelterPhoneNumber"
                              disabled
                            />
                          </p-iftalabel>
                        </p-inputgroup>
                      </div>
                      <div class="col-span-6">
                        <p-inputgroup>
                          <p-iftalabel>
                            <label for="animalShelter">
                              {{
                                'animalDetails.general.shelter.mailAddress'
                                  | transloco
                              }}
                            </label>
                            <input
                              type="text"
                              [class.no-border]="!isEditingMode"
                              pInputText
                              [value]="shelter.mailAddress"
                              id="animalShelterMailAddress"
                              disabled
                            />
                          </p-iftalabel>
                        </p-inputgroup>
                      </div>
                    </div>
                  }
                </p-accordion-content>
              </p-accordion-panel>
            }
          </p-accordion>
        </div>
      </div>
    </p-panel>
}

<ng-template #generalForm let="key" let-animalOrigItem="animalOrigItem">
  <div class="">
    <div class="grid grid-cols-12 gap-2">
      @if (isEditingMode || animalOrigItem?.location) {
        <div class="col-span-6">
          <p-inputgroup>
            <p-iftalabel>
              <label for="location">
                {{ 'animalAdd.origin.location' | transloco }}
              </label>
              <input
                type="text"
                [class.no-border]="!isEditingMode"
                pInputText
                [(ngModel)]="animalOrigItem.location"
                id="location"
                [disabled]="!isEditingMode"
              />
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      @if (isEditingMode || animalOrigItem?.type) {
        <div class="col-span-6">
          <p-inputgroup>
            <p-iftalabel>
              <label for="originReasonForTransfer">
                {{ 'animalAdd.origin.reasonForTransfer' | transloco }}
                @if (isEditingMode) {
                  <span class="required">*</span>
                }
              </label>

              @if (!isEditingMode) {
                <input
                  type="text"
                  pInputText
                  [value]="
                    animalOrigItem.type
                      ? ('animalOrigin.types.' + animalOrigItem.type
                        | transloco)
                      : ''
                  "
                  id="originReasonForTransfer"
                  [disabled]="!isEditingMode"
                />
              } @else {
                <p-select
                  id="originReasonForTransfer"
                  [options]="originReasonForTransfer"
                  [(ngModel)]="selectedOptionReasonTransfer"
                  (ngModelChange)="validateGeneralForm()"
                  optionLabel="name"
                  appendTo="body"
                  [disabled]="!isEditingMode"
                />
              }
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      <div class="col-span-6">
        @if (!isEditingMode) {
          <p-inputgroup>
            <p-iftalabel>
              <label for="dateOfReceipt">
                {{ 'animalAdd.origin.dateOfReceipt' | transloco }}
              </label>
              <input
                type="text"
                pInputText
                [value]="
                  animalOrigItem.dateOfReceipt
                    ? (animalOrigItem.dateOfReceipt | date: 'dd.MM.yyyy')
                    : ''
                "
                id="dateOfReceipt"
                disabled
              />
            </p-iftalabel>
          </p-inputgroup>
        } @else {
          <app-custom-date-picker
            [id]="'dateOfReceipt'"
            [label]="'animalAdd.origin.dateOfReceipt'"
            [rawInput]="
              animalOrigItem.dateOfReceipt
                ? (animalOrigItem.dateOfReceipt | date: 'yyyy-MM-dd') + ''
                : null
            "
            (valueChange)="
              animalOrigItem.dateOfReceipt = $event; validateGeneralForm()
            "
            [disabled]="!isEditingMode"
            [required]="true"
          />
        }
      </div>
      @if (animalOrigItem?.competentAuthority?.id && !isEditingMode) {
        <div class="col-span-12">
          <p-inputgroup>
            <p-iftalabel>
              <label for="competentAuthorityId">
                {{ 'animalAdd.origin.competentAuthority' | transloco }}
                @if (isEditingMode) {
                  <span class="required">*</span>
                }
              </label>
              @if (!isEditingMode) {
                <input
                  type="text"
                  class="w-full p-inputtext-sm"
                  [class.no-border]="!isEditingMode"
                  pInputText
                  [value]="
                    cityName[animalOrigItem?.competentAuthority?.id ?? '']
                  "
                  disabled
                />
              }
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      @if (
        isEditingMode &&
        (selectedOptionReasonTransfer?.value === 'found_animal' ||
          selectedOptionReasonTransfer?.value === 'take_away' ||
          selectedOptionReasonTransfer?.value === 'wild_found')
      ) {
        <div class="col-span-6">
          <p-inputgroup>
            <p-iftalabel>
              <label for="competentAuthorityId">
                {{ 'animalAdd.origin.competentAuthority' | transloco }}
                @if (isEditingMode) {
                  <span class="required">*</span>
                }
              </label>
              @if (isEditingMode) {
                <p-select
                  class="p-inputdropdown-sm w-full"
                  id="competentAuthorityId"
                  [options]="originCompetentAuthorityOptions"
                  optionLabel="name"
                  optionValue="id"
                  [(ngModel)]="editingItem.competentAuthorityId"
                  (ngModelChange)="validateGeneralForm()"
                  [required]="true"
                  appendTo="body"
                />
              }
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      @if (isEditingMode || animalOrigItem?.specialInformation) {
        <div class="col-span-12">
          <p-inputgroup>
            <p-iftalabel>
              <label for="specialInformation">
                {{ 'animalAdd.origin.specialInformation' | transloco }}
              </label>
              <textarea
                pInputText
                area
                class="p-inputtext-sm w-full"
                id="specialInformation"
                rows="5"
                [(ngModel)]="animalOrigItem.specialInformation"
                [disabled]="!isEditingMode"
              ></textarea>
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
    </div>
    <div class="grid gap-2">
      @if (!isEditingMode && animalOrigItem?.conditionOfCare) {
        <div class="col-span-6">
          <label class="field-title">
            {{ 'animalAdd.origin.conditionOfCare.headline' | transloco }}
          </label>
          <div class="flex flex-wrap gap-3 p-2">
            <p-radioButton
              inputId="conditionBad"
              value="bad"
              [(ngModel)]="animalOrigItem.conditionOfCare"
              [disabled]="true"
            />
            <label for="conditionBad" class="ml-2">
              {{ 'animalAdd.origin.conditionOfCare.bad' | transloco }}
            </label>
            <p-radioButton
              inputId="conditionMedium"
              value="medium"
              [(ngModel)]="animalOrigItem.conditionOfCare"
              [disabled]="true"
            />
            <label for="conditionMedium" class="ml-2">
              {{ 'animalAdd.origin.conditionOfCare.medium' | transloco }}
            </label>
            <p-radioButton
              inputId="conditionGood"
              value="good"
              [(ngModel)]="animalOrigItem.conditionOfCare"
              [disabled]="true"
            />
            <label for="conditionGood" class="ml-2">
              {{ 'animalAdd.origin.conditionOfCare.good' | transloco }}
            </label>
          </div>
        </div>
      }
      @if (!isEditingMode && animalOrigItem?.nutritionalStatus) {
        <div class="col-span-6">
          <label class="field-title">
            {{ 'animalAdd.origin.nutritionalStatus.headline' | transloco }}
          </label>
          <div class="flex flex-wrap gap-3 p-2">
            <p-radioButton
              inputId="nutritionBad"
              value="bad"
              [(ngModel)]="animalOrigItem.nutritionalStatus"
              [disabled]="true"
            />
            <label for="nutritionBad" class="ml-2">
              {{ 'animalAdd.origin.nutritionalStatus.bad' | transloco }}
            </label>
            <p-radioButton
              inputId="nutritionMedium"
              value="medium"
              [(ngModel)]="animalOrigItem.nutritionalStatus"
              [disabled]="true"
            />
            <label for="nutritionMedium" class="ml-2">
              {{ 'animalAdd.origin.nutritionalStatus.medium' | transloco }}
            </label>
            <p-radioButton
              inputId="nutritionGood"
              value="good"
              [(ngModel)]="animalOrigItem.nutritionalStatus"
              [disabled]="true"
            />
            <label for="nutritionGood" class="ml-2">
              {{ 'animalAdd.origin.nutritionalStatus.good' | transloco }}
            </label>
          </div>
        </div>
      }
      @if (!isEditingMode && hasAnyBcs(animalOrigItem)) {
        <div class="col-span-12 mt-5">
          @if (animalOrigItem.careCondition?.length) {
            <div class="mb-2">
              <label>{{ 'animalAdd.origin.conditionOfCare.headline' | transloco }}</label>
              <div class="w-full flex flex-wrap gap-2 p-2">
                @for (c of animalOrigItem.careCondition; track c) {
                  <p-chip [label]="getCareLabel(c)" />
                }
              </div>
            </div>
          }
          @if (animalOrigItem.bcsNutrition) {
            <div class="mb-2">
              <label>{{ 'animalAdd.origin.nutritionalStatus.headline' | transloco }}</label>
              <div class="w-full flex flex-wrap gap-2 p-2">
                <p-chip [label]="getNutritionLabel(animalOrigItem.bcsNutrition)" />
              </div>
            </div>
          }
          @if (animalOrigItem.temperament?.length) {
            <div class="mb-2">
              <label>{{ 'animalAdd.general.foundAnimal.temperament' | transloco }}</label>
              <div class="w-full flex flex-wrap gap-2 p-2">
                @for (t of animalOrigItem.temperament; track t) {
                  <p-chip [label]="getTemperamentLabel(t)" />
                }
              </div>
            </div>
          }
        </div>
      }
      @if (isEditingMode) {
        <div class="col-span-12">
          <app-body-condition-score
            [careCtrl]="bcsCareCtrl"
            [nutritionCtrl]="bcsNutritionCtrl"
            [temperamentCtrl]="bcsTemperamentCtrl"
          />
        </div>
      }

      @if (isEditingMode || animalOrigItem?.otherComments) {
        <div class="col-span-12">
          <p-inputgroup>
            <p-iftalabel>
              <label for="originOtherComments">
                {{ 'animalAdd.origin.otherComments' | transloco }}
              </label>
              <textarea
                pInputText
                area
                class="p-inputtext-sm w-full"
                id="originOtherComments"
                rows="5"
                [(ngModel)]="animalOrigItem.otherComments"
                [disabled]="!isEditingMode"
              ></textarea>
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
    </div>
  </div>
</ng-template>
<ng-template #foundAnimalDisplay let-animalOrigItem="animalOrigItem">
  <p-accordion [multiple]="true" [value]="['0', '1', '2', '3', 'sentEmails']">
    <!-- Panel 0: Grunddaten -->
    <p-accordion-panel value="0">
      <p-accordion-header>
        {{ 'animalAdd.general.basicData.headline' | transloco }}
      </p-accordion-header>

      <p-accordion-content>
        <div class="grid grid-cols-12 gap-2">
          @if (animalOrigItem.dateOfReceipt) {
            <div class="col-span-6">
              <p-inputgroup>
                <p-iftalabel>
                  <label for="fa_dateOfReceipt">
                    {{ 'animalAdd.origin.dateOfReceipt' | transloco }}
                  </label>
                  <input
                    id="fa_dateOfReceipt"
                    type="text"
                    pInputText
                    class="w-full p-inputtext-sm no-border"
                    [value]="animalOrigItem.dateOfReceipt | date: 'dd.MM.yyyy'"
                    disabled
                  />
                </p-iftalabel>
              </p-inputgroup>
            </div>
          }

          @if (animalOrigItem.dateOfReceipt) {
            <div class="col-span-6">
              <p-inputgroup>
                <p-iftalabel>
                  <label for="fa_foundTime">
                    {{ 'animalAdd.general.foundAnimal.time' | transloco }}
                  </label>
                  <input
                    id="fa_foundTime"
                    type="text"
                    pInputText
                    class="w-full p-inputtext-sm no-border"
                    [value]="formatTime(animalOrigItem.dateOfReceipt) + ' Uhr'"
                    disabled
                  />
                </p-iftalabel>
              </p-inputgroup>
            </div>
          }

          @if (animalOrigItem.location) {
            <div class="col-span-6">
              <p-inputgroup>
                <p-iftalabel>
                  <label for="fa_location">
                    {{ 'animalAdd.origin.location' | transloco }}
                  </label>
                  <input
                    id="fa_location"
                    type="text"
                    pInputText
                    class="w-full p-inputtext-sm no-border"
                    [value]="animalOrigItem.location"
                    disabled
                  />
                </p-iftalabel>
              </p-inputgroup>
            </div>
          }

          @if (animalOrigItem.competentAuthority?.id) {
            <div class="col-span-6">
              <p-inputgroup>
                <p-iftalabel>
                  <label for="fa_competentAuthority">
                    {{ 'animalAdd.origin.competentAuthority' | transloco }}
                  </label>
                  <input
                    id="fa_competentAuthority"
                    type="text"
                    pInputText
                    class="w-full p-inputtext-sm no-border"
                    [value]="
                      cityName[animalOrigItem.competentAuthority.id] ??
                      animalOrigItem.competentAuthority.name
                    "
                    disabled
                  />
                </p-iftalabel>
              </p-inputgroup>
            </div>
          }

          @if (animalOrigItem.specialInformation) {
            <div class="col-span-6">
              <p-inputgroup>
                <p-iftalabel>
                  <label for="fa_specialInformation">
                    {{ 'animalAdd.origin.specialInformation' | transloco }}
                  </label>
                  <textarea
                    id="fa_specialInformation"
                    pInputText
                    class="w-full p-inputtext-sm no-border"
                    rows="6"
                    [value]="animalOrigItem.specialInformation"
                    disabled
                  ></textarea>
                </p-iftalabel>
              </p-inputgroup>
            </div>
          }

          @if (animalOrigItem.otherComments) {
            <div class="col-span-6">
              <p-inputgroup>
                <p-iftalabel>
                  <label for="fa_otherComments">
                    {{ 'animalAdd.origin.otherComments' | transloco }}
                  </label>
                  <textarea
                    id="fa_otherComments"
                    pInputText
                    class="w-full p-inputtext-sm no-border"
                    rows="6"
                    [value]="animalOrigItem.otherComments"
                    disabled
                  ></textarea>
                </p-iftalabel>
              </p-inputgroup>
            </div>
          }
          @if (animalOrigItem.finderTransferMode === 'broughtByFinder') {
            <div class="col-span-12">
              <p-inputgroup>
                <p-iftalabel>
                  <label for="fa_transferMode">
                    {{
                      'animalAdd.general.foundAnimal.transferMode' | transloco
                    }}
                  </label>
                  <input
                    id="fa_transferMode"
                    type="text"
                    pInputText
                    class="w-full p-inputtext-sm no-border"
                    value="Das Tier wurde vom Findenden ins Tierheim gebracht."
                    disabled
                  />
                </p-iftalabel>
              </p-inputgroup>
            </div>
          }

          @if (animalOrigItem.finderTransferMode === 'pickedUp') {
            <div class="col-span-12">
              <p-inputgroup>
                <p-iftalabel>
                  <label for="fa_transferModePickedUp">
                    {{
                      'animalAdd.general.foundAnimal.transferMode' | transloco
                    }}
                  </label>
                  <input
                    id="fa_transferModePickedUp"
                    type="text"
                    pInputText
                    class="w-full p-inputtext-sm no-border"
                    [value]="
                      'Das Tier wurde ' +
                      (animalOrigItem.pickedUpTime
                        ? 'um ' +
                          formatTime(animalOrigItem.pickedUpTime) +
                          ' Uhr '
                        : 'um ______ Uhr ') +
                      'von ' +
                      (animalOrigItem.pickedUpByName
                        ? animalOrigItem.pickedUpByName
                        : '____') +
                      ' abgeholt.'
                    "
                    disabled
                  />
                </p-iftalabel>
              </p-inputgroup>
            </div>
          }

          @if (animalOrigItem.foundStatus) {
            <div class="col-span-6">
              <p-inputgroup>
                <p-iftalabel>
                  <label for="fa_foundStatus">
                    {{ 'animalAdd.general.foundAnimal.status' | transloco }}
                  </label>
                  <input
                    id="fa_foundStatus"
                    type="text"
                    pInputText
                    class="w-full p-inputtext-sm no-border"
                    [value]="
                      'foundStatus.' + animalOrigItem.foundStatus | transloco
                    "
                    disabled
                  />
                </p-iftalabel>
              </p-inputgroup>
            </div>
          }

          @if (animalOrigItem.pickupDateTime || animalOrigItem.pickupUserName) {
            <div class="col-span-6">
              <p-inputgroup>
                <p-iftalabel>
                  <label for="fa_pickup">
                    {{ 'animalAdd.general.foundAnimal.pickup' | transloco }}
                  </label>
                  <input
                    id="fa_pickup"
                    type="text"
                    pInputText
                    class="w-full p-inputtext-sm no-border"
                    [value]="
                      (animalOrigItem.pickupDateTime
                        ? (animalOrigItem.pickupDateTime | date: 'dd.MM.yyyy HH:mm') + ' Uhr'
                        : '') +
                      (animalOrigItem.pickupUserName
                        ? ' – ' + animalOrigItem.pickupUserName
                        : '')
                    "
                    disabled
                  />
                </p-iftalabel>
              </p-inputgroup>
            </div>
          }

          @if (animalOrigItem.finderDataMayBeShared === true) {
            <div class="col-span-6">
              <p-inputgroup>
                <p-iftalabel>
                  <label for="fa_shareConsent">
                    {{ 'animalAdd.general.finderContact.headline' | transloco }}
                  </label>
                  <input
                    id="fa_shareConsent"
                    type="text"
                    pInputText
                    class="w-full p-inputtext-sm no-border"
                    value="Finderdaten dürfen an den Tierbesitzer weitergegeben werden."
                    disabled
                  />
                </p-iftalabel>
              </p-inputgroup>
            </div>
          }

          @if (animalOrigItem.animalRemainsWithFinder === true) {
            <div class="col-span-6">
              <p-inputgroup>
                <p-iftalabel>
                  <label for="fa_remainsWithFinder">
                    {{ 'animalAdd.general.finderContact.headline' | transloco }}
                  </label>
                  <input
                    id="fa_remainsWithFinder"
                    type="text"
                    pInputText
                    class="w-full p-inputtext-sm no-border"
                    value="Das Tier verbleibt beim Findenden."
                    disabled
                  />
                </p-iftalabel>
              </p-inputgroup>
            </div>
          }
        </div>
      </p-accordion-content>
    </p-accordion-panel>

    <!-- Panel 2: Body Condition Score -->
    @if (hasAnyBcs(animalOrigItem)) {
      <p-accordion-panel value="1">
        <p-accordion-header> Fundtier Zustand </p-accordion-header>

        <p-accordion-content>
          <div class="grid grid-cols-12 gap-2">
            @if (animalOrigItem.careCondition?.length) {
              <div class="col-span-12">
                <label>{{
                  'animalAdd.origin.conditionOfCare.headline' | transloco
                }}</label>
                <div class="w-full flex flex-wrap gap-2 p-2">
                  @for (c of animalOrigItem.careCondition; track c) {
                    <p-chip [label]="getCareLabel(c)"></p-chip>
                  }
                </div>
              </div>
            }

            @if (animalOrigItem.bcsNutrition) {
              <div class="col-span-12">
                <label>
                  {{
                    'animalAdd.origin.nutritionalStatus.headline' | transloco
                  }}
                </label>
                <div class="w-full flex flex-wrap gap-2 p-2">
                  <p-chip
                    [label]="getNutritionLabel(animalOrigItem.bcsNutrition)"
                  ></p-chip>
                </div>
              </div>
            }

            @if (animalOrigItem.temperament?.length) {
              <div class="col-span-12">
                <label>{{
                  'animalAdd.general.foundAnimal.temperament' | transloco
                }}</label>
                <div class="w-full flex flex-wrap gap-2 p-2">
                  @for (t of animalOrigItem.temperament; track t) {
                    <p-chip [label]="getTemperamentLabel(t)"></p-chip>
                  }
                </div>
              </div>
            }
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    }

    @if (sentEmailsByOriginId[animalOrigItem.id]?.length || animalOrigItem.authorityInformation) {
      <p-accordion-panel value="sentEmails">
        <p-accordion-header>Versendete E-Mails</p-accordion-header>
        <p-accordion-content>
          @if (animalOrigItem.authorityInformation) {
            <div class="text-sm text-gray-600 bg-gray-50 rounded p-2 mb-2 whitespace-pre-wrap">{{ animalOrigItem.authorityInformation }}</div>
          }
          <div class="flex flex-col gap-1 p-1">
            @for (email of sentEmailsByOriginId[animalOrigItem.id]; track email.id) {
              <div class="text-sm text-gray-700">
                @if (email.recipientName) {
                  <span class="font-medium">{{ email.recipientName }}: </span>
                }
                <span>{{ email.recipientEmail }}</span>
                <span class="text-gray-400 ml-2">{{ email.sentAt | date: 'dd.MM.yyyy HH:mm' }}</span>
              </div>
            }
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    }
  </p-accordion>
</ng-template>

<ng-template #contactForm let-contact="contact">
  <ng-container>
    <div class="grid gap-2 grid-cols-12">
      @if (isEditingMode || contact.gender) {
        <div class="col-span-6">
          <p-inputgroup>
            <p-iftalabel>
              <label for="personSalutation">
                {{ 'animalAdd.origin.person.salutation' | transloco }}
              </label>

              @if (!isEditingMode) {
                <input
                  pInputText
                  type="text"
                  class="w-full p-inputtext-sm no-border"
                  [value]="'salutation.' + contact.gender | transloco"
                  [disabled]="!isEditingMode"
                  id="personSalutation"
                />
              } @else {
                <p-select
                  class="p-inputdropdown-sm w-full"
                  [options]="originSubmittedPersonSalutation"
                  optionLabel="name"
                  optionValue="value"
                  [(ngModel)]="contact.gender"
                  id="personSalutation"
                  appendTo="body"
                  [disabled]="!isEditingMode"
                >
                </p-select>
              }
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      @if (isEditingMode || contact.idCardNumber) {
        <div class="col-span-6">
          <p-inputgroup>
            <p-iftalabel>
              <label for="personIdCardNumber">
                {{ 'animalAdd.origin.person.idCardNumber' | transloco }}
              </label>
              <input
                type="text"
                [class.no-border]="!isEditingMode"
                [value]="contact.idCardNumber"
                id="personIdCardNumber"
                pInputText
                [disabled]="!isEditingMode"
              />
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      @if (isEditingMode || contact.firstName) {
        <div class="col-span-6">
          <p-inputgroup>
            <p-iftalabel>
              <label for="personFirstName">
                {{ 'animalAdd.origin.person.firstName' | transloco }}
              </label>
              <input
                type="text"
                [class.no-border]="!isEditingMode"
                [value]="contact.firstName"
                id="personFirstName"
                pInputText
                [disabled]="!isEditingMode"
              />
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      @if (isEditingMode || contact.lastName) {
        <div class="col-span-6">
          <p-inputgroup>
            <p-iftalabel>
              <label for="personLastName">
                {{ 'animalAdd.origin.person.lastName' | transloco }}
              </label>
              <input
                type="text"
                [class.no-border]="!isEditingMode"
                [value]="contact.lastName"
                id="personLastName"
                pInputText
                [disabled]="!isEditingMode"
              />
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      @if (isEditingMode || contact.companyName) {
        <div class="col-span-12">
          <p-inputgroup>
            <p-iftalabel>
              <label for="companyName">
                {{ 'animalAdd.origin.person.companyName' | transloco }}
              </label>
              <input
                type="text"
                [class.no-border]="!isEditingMode"
                [value]="contact.companyName"
                id="companyName"
                pInputText
                [disabled]="!isEditingMode"
              />
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      @if (isEditingMode || contact.street) {
        <div class="col-span-6">
          <p-inputgroup>
            <p-iftalabel>
              <label for="personStreet">
                {{ 'animalAdd.origin.person.street' | transloco }}
              </label>
              <input
                type="text"
                [class.no-border]="!isEditingMode"
                [value]="contact.street"
                id="personStreet"
                pInputText
                [disabled]="!isEditingMode"
              />
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      @if (isEditingMode || contact.zipCode) {
        <div class="col-span-6">
          <p-inputgroup>
            <p-iftalabel>
              <label for="personZipCode">
                {{ 'animalAdd.origin.person.zipCode' | transloco }}
              </label>
              <input
                type="text"
                [class.no-border]="!isEditingMode"
                [value]="contact.zipCode"
                id="personZipCode"
                pInputText
                [disabled]="!isEditingMode"
              />
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      @if (isEditingMode || contact.city) {
        <div class="col-span-12">
          <p-inputgroup>
            <p-iftalabel>
              <label for="personCity">
                {{ 'animalAdd.origin.person.city' | transloco }}
              </label>
              <input
                pInputText
                type="text"
                [class.no-border]="!isEditingMode"
                [value]="contact.city"
                id="personCity"
                [disabled]="!isEditingMode"
              />
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      @if (contact.phoneNumbers?.length) {
        @for (entry of contact.phoneNumbers; track entry; let index = $index) {
          <div class="col-span-6">
            <p-inputgroup>
              <p-iftalabel>
                @if (entry.type === phoneNumbersEntryType.MOBILE) {
                  <label [for]="'number' + index">
                    {{ 'animalAdd.origin.person.mobileNumber' | transloco }}
                  </label>
                } @else if (entry) {}
                @switch (entry.type) {
                  @case (phoneNumbersEntryType.MOBILE) {
                    <label [for]="'number' + index">
                      {{ 'animalAdd.origin.person.mobileNumber' | transloco }}
                    </label>
                  }
                  @case (phoneNumbersEntryType.PRIVATE) {
                    <label for="personNumber">
                      {{ 'animalAdd.origin.person.privateNumber' | transloco }}
                    </label>
                  }
                  @case (phoneNumbersEntryType.BUSINESS) {
                    <label [for]="'number' + index">
                      {{ 'animalAdd.origin.person.businessNumber' | transloco }}
                    </label>
                  }
                  @case (phoneNumbersEntryType.CUSTOM) {
                    <label [for]="'number' + index">
                      {{ 'animalAdd.origin.person.privateNumber' | transloco }}
                    </label>
                  }
                  @default {
                    <label [for]="'number' + index">
                      {{ 'animalAdd.origin.person.privateNumber' | transloco }}
                    </label>
                  }
                }
                <input
                  type="text"
                  class="p-inputtext-sm"
                  [class.no-border]="!isEditingMode"
                  [value]="entry.number"
                  [id]="'number' + index"
                  pInputText
                  [disabled]="!isEditingMode"
                />
              </p-iftalabel>
            </p-inputgroup>
          </div>
          <div class="col-span-6">
            <p-inputgroup>
              <p-iftalabel>
                <label [for]="'personMobileNumberName' + index">
                  {{ 'animalAdd.origin.person.mobileNumberName' | transloco }}
                </label>
                <input
                  type="text"
                  [class.no-border]="!isEditingMode"
                  [value]="entry.label"
                  [id]="'personMobileNumberName' + index"
                  pInputText
                  [disabled]="!isEditingMode"
                />
              </p-iftalabel>
            </p-inputgroup>
          </div>
        }
      }
      @if (isEditingMode || contact.birthday) {
        <div class="col-span-6">
          <p-inputgroup>
            <p-iftalabel>
              <label for="personBirthday">
                {{ 'animalAdd.origin.person.birthday' | transloco }}
              </label>
              <input
                type="text"
                [class.no-border]="!isEditingMode"
                [value]="contact.birthday | date: 'dd.MM.yyyy'"
                id="personBirthday"
                pInputText
                [disabled]="!isEditingMode"
              />
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      @if (isEditingMode || contact.birthPlace) {
        <div class="col-span-6">
          <p-inputgroup>
            <p-iftalabel>
              <label for="personBirthPlace">
                {{ 'animalAdd.origin.person.birthPlace' | transloco }}
              </label>
              <input
                type="text"
                [class.no-border]="!isEditingMode"
                [value]="contact.birthPlace"
                id="personBirthPlace"
                pInputText
                [disabled]="!isEditingMode"
              />
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      @if (isEditingMode || contact.email) {
        <div class="col-span-6">
          <p-inputgroup>
            <p-inputgroup-addon>
              @if (contact.email) {
                <a
                  class="absolute"
                  [href]="'mailto:' + contact.email"
                  [pTooltip]="'animalAdd.origin.person.email' | transloco"
                  tooltipPosition="top"
                >
                  <i class="pi pi-envelope"></i>
                </a>
              }
            </p-inputgroup-addon>
            <p-iftalabel>
              <label for="personEmail">
                {{ 'animalAdd.origin.person.email' | transloco }}
              </label>
              <input
                type="text"
                [class.no-border]="!isEditingMode"
                [value]="contact.email"
                id="personEmail"
                pInputText
                [disabled]="!isEditingMode"
              />
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
      @if (isEditingMode || contact.url) {
        <div class="col-span-6">
          <p-inputgroup>
            <p-inputgroup-addon>
              @if (contact.url) {
                <a
                  class="relative w-full h-full flex items-center justify-center"
                  target="_blank"
                  [href]="contact.url"
                  [pTooltip]="'animalAdd.origin.person.url' | transloco"
                  tooltipPosition="top"
                >
                  <i class="pi pi-globe"></i>
                </a>
              }
            </p-inputgroup-addon>
            <p-iftalabel>
              <label for="personUrl">
                {{ 'animalAdd.origin.person.url' | transloco }}
              </label>
              <input
                type="text"
                [class.no-border]="!isEditingMode"
                [value]="contact.url"
                id="personUrl"
                pInputText
                [disabled]="!isEditingMode"
              />
            </p-iftalabel>
          </p-inputgroup>
        </div>
      }
    </div>
  </ng-container>
</ng-template>

<p-dialog
  [(visible)]="openEdit"
  [style]="{ width: '90vw', height: '90vh' }"
  [modal]="true"
  [draggable]="false"
  [blockScroll]="true"
  [resizable]="false"
  (onHide)="toggleEditDialog(false, '', editDialogOriginKey)"
>
  <ng-template #header>
    <div class="flex items-center">
      <div class="px-4">
        <app-animal-current-category [animal]="animal" />
      </div>
      <div class="flex px-4 animal-name-headline">
        @if (animal) {
          <app-animal-in-stock-icon [animal]="animal" />
        }
        {{ animal.displayName }}
      </div>
      <div class="flex px-4 justify-center items-center">
        <img
          src="../../../../assets/images/icons/icon_key_green.svg"
          alt="key"
        />
        <p>
          {{ animal.bookNumber }}
          @if (animal.oldBookNumber) {
            <span>({{ animal.oldBookNumber }})</span>
          }
        </p>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    @if (editType === 'general') {
      <ng-container
        *ngTemplateOutlet="
          generalForm;
          context: { key: editDialogOriginKey, animalOrigItem: editingItem }
        "
      />
    }
    @if (editType === 'contactRef') {
      <div class="grid grid-cols-12 gap-2 p-2">
        <div class="col-span-6">
          <p-inputgroup>
            <p-iftalabel>
              <label for="contactRefType">{{
                'contacts.type' | transloco
              }}</label>
              <p-select
                id="contactRefType"
                [options]="contactTypeOptions"
                optionLabel="name"
                optionValue="value"
                [(ngModel)]="editingContactRef.type"
                appendTo="body"
              />
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="col-span-6">
          <p-inputgroup>
            <p-iftalabel>
              <label for="contactRefLabel">{{
                'contacts.label' | transloco
              }}</label>
              <input
                id="contactRefLabel"
                pInputText
                [(ngModel)]="editingContactRef.label"
              />
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="col-span-12">
          <app-choose-contact
            [allowEmptyValid]="true"
            [newContact]="editingContact"
            [isExistingContact]="existingContact"
            (newContactUpdated)="onContactUpdate($event)"
            (validationStatusChanged)="onValidationStatusChanged($event)"
            (existingContactSelected)="onExistingContactSelected($event)"
            (existingContactUpdated)="onExistingContactUpdated($event)"
          />
        </div>
      </div>
    }
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex gap-2">
      <p-button
        (click)="toggleEditDialog(false, '', editDialogOriginKey)"
        label="{{ 'modal.cancel' | transloco }}"
        icon="pi pi-times"
        [text]="true"
      />
      <p-button
        (click)="save(editingItem)"
        [disabled]="!validationStatusChanged"
        label="{{ 'modal.save' | transloco }}"
        icon="pi pi-save"
      />
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  header="PDF Ansicht"
  [(visible)]="pdfDialogVisible"
  [modal]="true"
  [blockScroll]="true"
  [style]="{ width: '90vw', 'max-width': '900px' }"
  [contentStyle]="{ height: '75vh' }"
>
  <app-pdf-viewer [pdf]="pdfBlob" height="70vh" />
</p-dialog>

@if (sendFoundReportDialogVisible && animal) {
  <app-send-found-report-dialog
    [(visible)]="sendFoundReportDialogVisible"
    [animal]="animal"
    [id]="sendFoundReportOriginId"
    [availableContacts]="sendFoundReportContacts"
    [securingReport]="sendFoundReportIsSecuring"
    [authorityInformation]="sendFoundReportOriginId ? (animalOrigItems[sendFoundReportOriginId]?.authorityInformation ?? null) : null"
    (sent)="onSendFoundReportSent($event)"
  />
}

<app-sent-emails-dialog
  [(visible)]="sentEmailsDialogVisible"
  [emails]="sentEmailsDialogData"
/>

